import { createContext } from "react";

interface IProductTileBrandInfoClickContextProps {
  onBrandClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  onBrandLinkFocus?: () => void;
  onBrandLinkBlur?: () => void;
  generateBrandUrl?: (brandToken: string) => string;
}

export const ProductTileBrandInfoClickContext =
  createContext<IProductTileBrandInfoClickContextProps>({});
